module.exports = __webpack_public_path__ + "static/media/clipboard.b4925758.svg";